import React, { useEffect } from 'react';
import clsx from 'clsx';
import Image from 'next/image';
import { generateDataImage } from '@edx/helpers/data-image';

type Props = {
  containerClassName?: string;
  className?: string;
  name: string;
  size?: number;
  round?: boolean;
  src?: string | null;
  noBorder?: boolean;
};

export const Avatar: React.FC<Props> = ({
  containerClassName,
  className,
  name,
  size = 40,
  round = true,
  src,
  noBorder,
}) => {
  const [image, setImage] = React.useState<string | null>(null);

  useEffect(() => {
    setImage(src || generateDataImage({ name }));
  }, [src, name, setImage]);

  return (
    <div className={clsx('relative flex-shrink-0', containerClassName)}>
      {image && (
        <div className={clsx('w-10 h-10', className, { 'rounded-full': round, 'border-2 border-white': !noBorder })}>
          <Image
            className={clsx({ 'rounded-full': round })}
            src={image}
            width={size}
            height={size}
            alt={name}
            unoptimized
          />
        </div>
      )}
    </div>
  );
};
